import { selectIsSubscriber } from '../subscription'
import { useSelector } from 'react-redux'

export function useIsSubscriber() {
  return useSelector(selectIsSubscriber)
}

export default useIsSubscriber
